import React from 'react';
import { RefreshCw, Search } from 'lucide-react';

import { Button } from '@/Modules/Core/Components/shadcn/button';
import { Input } from '@/Modules/Core/Components/shadcn/input';
import { cn } from '@/lib/utils';

const FileChangeToolbar = ({
  searchTerm,
  onSearchChange,
  searchPlaceholder,
  onRefresh,
  refreshing = false,
  refreshLabel,
  options = [],
  activeOption,
  onOptionChange,
  getOptionClassName,
}) => (
  <div className="space-y-4 bg-transparent py-2">
    <div className="flex flex-col gap-4 xl:flex-row xl:items-center">
      <div className="relative flex-1">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={searchPlaceholder}
          className="h-11 rounded-xl border-border/45 bg-transparent pl-9"
        />
      </div>

      <div className="flex items-center gap-3">
        <Button
          type="button"
          size="icon"
          variant="outline"
          className="border-border/40 bg-transparent hover:bg-accent/20"
          aria-label={refreshLabel}
          title={refreshLabel}
          onClick={onRefresh}
          disabled={refreshing}
        >
          <RefreshCw className={cn('h-4 w-4', refreshing && 'animate-spin')} />
        </Button>
      </div>
    </div>

    {options.length > 0 ? (
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option.id}
            type="button"
            className={cn(
              'inline-flex h-10 items-center gap-2 rounded-lg border px-4 text-sm font-medium transition-colors',
              getOptionClassName(activeOption, option.id)
            )}
            onClick={() => onOptionChange(option.id)}
          >
            {option.label}
          </button>
        ))}
      </div>
    ) : null}
  </div>
);

export default FileChangeToolbar;
